interface IsValueValidOptions {
  value: string;
  regex?: RegExp;
  maxLength?: number;
}

const doesPassRegex = (value: string, regex?: RegExp) => !regex || regex.test(value);

const doesPassMaxLength = (value: string, maxLength?: number) =>
  !maxLength || value.length <= maxLength;

export const isValueValid = ({ value, regex, maxLength }: IsValueValidOptions) =>
  doesPassRegex(value, regex) && doesPassMaxLength(value, maxLength);
